<template>
  <v-card>
    <v-toolbar dark color="primary">
      <v-btn icon dark @click="closeDialog">
        <v-icon>mdi-close</v-icon>
      </v-btn>

      <v-toolbar-title>{{ formTitle }}</v-toolbar-title>

      <v-spacer />

      <v-toolbar-items>
        <v-btn dark text @click="save"> Salvar </v-btn>
      </v-toolbar-items>
    </v-toolbar>

    <v-container>
      <v-row dense align="center" justify="space-between">
        <v-col>
          <v-text-field
            v-model="template.name"
            label="Nome do protocolo"
            :hide-details="errors.name === undefined"
            :error-messages="errors.name"
          />
        </v-col>

        <v-spacer />

        <v-col cols="auto">
          <v-switch v-model="specialControl" label="controle especial" />
        </v-col>
      </v-row>

      <v-tabs
        v-model="applicationRouteTab"
        show-arrows
        background-color="transparent"
        color="light-blue"
        @change="changeApplicationRoute"
      >
        <v-tab v-for="tabOption in tabOptions" :key="`tab-${tabOption.id}`">
          {{ tabOption.name }}
        </v-tab>
      </v-tabs>

      <v-tabs-items
        v-model="applicationRouteTab"
        :style="{ backgroundColor: 'transparent' }"
      >
        <v-tab-item
          v-for="tabOption in tabOptions"
          :key="`tab-${tabOption.id}`"
          eager
        >
          <v-row v-if="!showForm">
            <v-col cols="auto">
              <v-btn @click="showForm = true" color="light-blue" dark>
                Adicionar medicamento
              </v-btn>
            </v-col>
          </v-row>

          <PrescriptionFormGuidance
            v-if="tabOption.id === -1"
            v-show="showForm"
            :addItem="addGuidance"
            :removeItem="removeGuidance"
            :prescriptionGuidance="newGuidance"
            :prescriptionFrequencies="prescriptionFrequencies"
            :prescriptionPeriods="prescriptionPeriods"
            :prescriptionHowLongs="prescriptionHowLongs"
            :guidancePresets="prescriptionGuidancePresets"
          />

          <PrescriptionFormItem
            v-else
            v-show="showForm"
            :addItem="addItem"
            :removeItem="removeItem"
            :prescriptionItem="newItem"
            :applicationRoute="tabOption"
            :prescriptionFrequencies="prescriptionFrequencies"
            :prescriptionPeriods="prescriptionPeriods"
            :prescriptionHowLongs="prescriptionHowLongs"
          />
        </v-tab-item>
      </v-tabs-items>

      <v-row
        v-for="(prescriptionItems,
        routeId) in prescriptionItemsperApplicationRoute"
        :key="routeId"
      >
        <v-col>
          <v-row>
            <v-col class="text-h5 text-capitalize">
              {{ routeId }}
            </v-col>
          </v-row>

          <v-row
            dense
            v-for="prescriptionItem in prescriptionItems"
            :key="prescriptionItem.key"
          >
            <v-col>
              <PrescriptionFormItem
                :prescriptionItem="prescriptionItem"
                :addItem="addItem"
                :removeItem="removeItem"
                :applicationRoute="prescriptionItem.applicationRoute"
                :prescriptionFrequencies="prescriptionFrequencies"
                :prescriptionPeriods="prescriptionPeriods"
                :prescriptionHowLongs="prescriptionHowLongs"
                :visualization="true"
              />
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <v-row v-if="!lodash.isEmpty(prescriptionGuidances)">
        <v-col>
          <v-row>
            <v-col class="text-h5 text-capitalize"> Orientações </v-col>
          </v-row>

          <PrescriptionFormGuidance
            v-for="prescriptionGuidance in prescriptionGuidances"
            :key="prescriptionGuidance.key"
            :addItem="addGuidance"
            :removeItem="removeGuidance"
            :prescriptionGuidance="prescriptionGuidance"
            :prescriptionFrequencies="prescriptionFrequencies"
            :prescriptionPeriods="prescriptionPeriods"
            :prescriptionHowLongs="prescriptionHowLongs"
            :guidancePresets="prescriptionGuidancePresets"
            :visualization="true"
          />
        </v-col>
      </v-row>
    </v-container>
  </v-card>
</template>

<script>
import PrescriptionFormItem from "./item.vue";
import PrescriptionFormGuidance from "./guidance.vue";
// import PrescriptionItem from "@/components/prescription/item.vue";
// import PrescriptionGuidance from "@/components/prescription/guidance.vue";

export default {
  name: "ConfigPrescriptionForm",
  props: {
    formTitle: String,
    closeDialog: Function,
    refreshList: {
      type: Function,
      default: () => {},
    },
    template: {
      type: Object,
      default: () => {
        return {
          id: "",
          name: "",
          items: [
            {
              id: "",
              buildingInformation: {
                special_control: false,
                prescription_items: [],
                prescription_guidances: [],
              },
            },
          ],
        };
      },
    },
  },
  components: {
    PrescriptionFormItem,
    PrescriptionFormGuidance,
  },
  data() {
    return {
      errors: {},
      applicationRouteTab: null,
      medicineApplicationRoutes: [],
      showForm: true,
      newItem: {
        key: "",
        medicine_application_route_id: "",
        medicine_application_site_id: "",
        medicine_id: "",
        medicine_presentation_id: "",
        medicine_presentation_unity_id: "",
        presentation_quantity: 1,
        observation: "",
        actions: [],
        continuous: false,
      },
      newGuidance: {
        key: "",
        description: "",
      },
    };
  },
  apollo: {
    medicineApplicationRoutes: {
      query: require("@/graphql/medicine/medicine_application_routes.gql"),
      update(data) {
        return this.lodash.orderBy(
          data.medicineApplicationRoutes,
          ["createdAt"],
          ["desc"]
        );
      },
      fetchPolicy: "no-cache",
    },
    prescriptionFrequencies: {
      query: require("@/graphql/prescription/frequencies.gql"),
      fetchPolicy: "no-cache",
    },
    prescriptionPeriods: {
      query: require("@/graphql/prescription/periods.gql"),
      fetchPolicy: "no-cache",
    },
    prescriptionHowLongs: {
      query: require("@/graphql/prescription/how_longs.gql"),
      fetchPolicy: "no-cache",
    },
    prescriptionGuidancePresets: {
      query: require("@/graphql/prescription/guidance_presets.gql"),
      fetchPolicy: "no-cache",
    },
  },
  computed: {
    tabOptions() {
      let tabOptions = this.medicineApplicationRoutes;
      if (tabOptions.length > 0) {
        tabOptions.push({ id: -1, name: "Orientações" });
      }

      return tabOptions;
    },
    prescriptionItemsperApplicationRoute() {
      let prescriptionItems = this.lodash.map(
        this.prescriptionItems,
        (prescriptionItem) => {
          let applicationRoute = this.lodash.find(
            this.medicineApplicationRoutes,
            {
              id: prescriptionItem.medicine_application_route_id,
            }
          );

          return {
            ...prescriptionItem,
            applicationRoute: applicationRoute,
          };
        }
      );
      prescriptionItems = this.lodash.groupBy(
        prescriptionItems,
        "applicationRoute.name"
      );

      return prescriptionItems;
    },
    templateItem() {
      return this.lodash.first(this.template.items);
    },
    prescriptionItems: {
      set(prescriptionItems) {
        this.templateItem.buildingInformation.prescription_items = prescriptionItems;
      },
      get() {
        return this.templateItem.buildingInformation.prescription_items.map(
          (item) => {
            return {
              ...item,
              key: this.$randomKey(),
            };
          }
        );
      },
    },
    prescriptionGuidances: {
      set(prescriptionGuidances) {
        this.templateItem.buildingInformation.prescription_guidances = prescriptionGuidances;
      },
      get() {
        return this.templateItem.buildingInformation.prescription_guidances.map(
          (item) => {
            return {
              ...item,
              key: this.$randomKey(),
            };
          }
        );
      },
    },
    specialControl: {
      set(specialControl) {
        this.templateItem.buildingInformation.special_control = specialControl;
      },
      get() {
        return this.templateItem.buildingInformation.special_control;
      },
    },
  },
  methods: {
    validateTemplate() {
      const errorMsg = "Esse campo deve ser preenchido.";
      this.errors = {};

      if (!this.template.name) {
        this.errors.name = errorMsg;
      }

      if (Object.keys(this.errors).length === 0) {
        return true;
      }

      return false;
    },
    resetNewItem() {
      this.newItem = {
        ...this.newItem,
        key: "",
        medicine_application_route_id: "",
        medicine_application_site_id: "",
        medicine_id: "",
        medicine_presentation_id: "",
        medicine_presentation_unity_id: "",
        presentation_quantity: 1,
        observation: "",
        actions: [],
        continuous: false,
      };

      this.newGuidance = {
        ...this.newGuidance,
        key: "",
        description: "",
      };
    },
    changeApplicationRoute() {
      this.resetNewItem();
    },
    addItem(item) {
      let prescriptionItems = this.prescriptionItems;
      let itemIndex = this.lodash.findIndex(prescriptionItems, {
        key: item.key,
      });

      if (itemIndex === -1) {
        prescriptionItems.push({
          ...item,
          key: this.$randomKey(),
        });

        this.resetNewItem();
      } else {
        prescriptionItems[itemIndex] = item;
      }

      this.prescriptionItems = [];
      this.$nextTick(() => {
        this.prescriptionItems = prescriptionItems;
      });
    },
    removeItem(item) {
      let prescriptionItems = this.prescriptionItems;
      let itemIndex = this.lodash.findIndex(prescriptionItems, {
        key: item.key,
      });

      prescriptionItems.splice(itemIndex, 1);
      this.prescriptionItems = [];
      this.prescriptionItems = prescriptionItems;
    },
    addGuidance(item) {
      let prescriptionGuidances = this.prescriptionGuidances;
      let itemIndex = this.lodash.findIndex(prescriptionGuidances, {
        key: item.key,
      });

      if (itemIndex === -1) {
        prescriptionGuidances.push({
          ...item,
          key: this.$randomKey(),
        });

        this.resetNewItem();
      } else {
        prescriptionGuidances[itemIndex] = item;
      }

      this.prescriptionGuidances = [];
      this.prescriptionGuidances = prescriptionGuidances;
    },
    removeGuidance(item) {
      let prescriptionGuidances = this.prescriptionGuidances;
      let itemIndex = this.lodash.findIndex(prescriptionGuidances, {
        key: item.key,
      });

      prescriptionGuidances.splice(itemIndex, 1);
      this.prescriptionGuidances = [];
      this.prescriptionGuidances = prescriptionGuidances;
    },
    save() {
      if (!this.validateTemplate()) return;

      this.apolloMutate({
        mutation: require("@/graphql/template/save_template.gql"),
        variables: {
          templateId: this.lodash.get(this.template, "id", ""),
          name: this.template.name,
        },
      }).then(({ data }) => {
        this.apolloMutate({
          mutation: require("@/graphql/template/save_template_item.gql"),
          variables: {
            templateId: data.saveTemplate.id,
            templateItemId: this.lodash.get(this.templateItem, "id", ""),
            templateType: "prescription",
            buildingInformation: JSON.stringify(
              this.templateItem.buildingInformation
            ),
          },
        }).then(() => {
          this.refreshList();

          this.$store.dispatch("createNotification", {
            message: "Cadastro salvo com sucesso.",
            type: "success",
          });

          this.closeDialog();
        });
      });
    },
  },
};
</script>

<style lang="scss" scoped></style>
